import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'connectionsSearchBy'
})
export class ConnectionsSearchBy implements PipeTransform {

  transform(results: any, term: any): any {
    if(term === undefined || term === '') {
      return results;
    } else {

      return results.filter((item) => {

        // Check against the title or associated tags and return that to the list
        if(item.display_name.toLowerCase().includes(term.toLowerCase())) {
            return true;
        }
      });
    }
  }
}
